import React from 'react';
import { Field as AkField, ErrorMessage as AkErrorMessage } from '@atlaskit/form';
import AkTextField from '@atlaskit/textfield';
import { useIntl } from '@atlassian/jira-intl';
import { EMPTY, HOLIDAY_NAME_PREFIX } from '../../../../../../../common/ui/constants.tsx';
import messages from './messages';
import { validateName } from './utils';

type Props = {
	fieldId: number | string;
	defaultName: string;
};

export const NameView = ({ fieldId, defaultName }: Props) => {
	const { formatMessage } = useIntl();
	return (
		<AkField
			name={`${HOLIDAY_NAME_PREFIX}${fieldId}`}
			label={formatMessage(messages.name)}
			defaultValue={defaultName}
			// @ts-expect-error - TS2322 - Type '(name: string) => string | undefined' is not assignable to type '(value: string | undefined, formState: Object, fieldState: Meta) => string | void | Promise<string | void>'.
			validate={validateName}
		>
			{({ fieldProps, error }) => (
				<>
					<AkTextField {...fieldProps} maxLength={63} />
					{error === EMPTY && <AkErrorMessage>{formatMessage(messages.empty)}</AkErrorMessage>}
				</>
			)}
		</AkField>
	);
};

export const Name = NameView;
